export default __webpack_public_path__ + "static/media/AIG-color.83906759.svg";